import { Box, Button, Modal, TextField, Typography } from "@mui/material"
import useUpdateEmail from "../../hooks/useraccount/useUpdateEmail"

export default function EmailUpdateModal({ open, onClose }: { open: boolean, onClose: () => void }) {
    const { setNewEmail, handleSubmitChangeEmail } = useUpdateEmail(onClose)

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={styles.modalBox} component="form" display="flex" flexDirection="column" rowGap="20px" onSubmit={handleSubmitChangeEmail}>
                <Typography variant="h6">Enter new email:</Typography>
                <TextField
                    id="outlined-basic"
                    label="Email"
                    variant="outlined"
                    required
                    onChange={e => setNewEmail(e.target.value)}
                    inputProps={{ maxLength: 128 }}
                    sx={{ backgroundColor: "grey.50" }}
                />
                <Button variant="contained" type="submit">Continue</Button>
            </Box>
        </Modal>
    )
}

const styles = {
    modalBox: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        padding: 4,
    }
}
